import { View, StyleSheet } from "react-native";
import BlankLayout from "../layouts/BlankLayout";
import Logo from "../components/general/logos/Logo/Logo";
import CustomText from "../components/common/general/CustomText/CustomText";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import { useAppConfig } from "../AppConfigProvider";
import useResponsiveScreen from "../hooks/useResponsiveScreen";

function MaintenanceModeView() {
  const appConfig = useAppConfig();
  const { isLarge } = useResponsiveScreen();

  return (
    <BlankLayout>
      <View style={isLarge ? styles.webContainer : styles.mobileContainer}>
        <View accessible={true}>
          <Logo name={appConfig.key} height={100} width={280} />
          <CustomSpacing type="vertical" size="m" />
          <CustomText text="System Maintenance" textType="display" size="xs" weight="bold" style={styles.centerText} />
        </View>
        <CustomSpacing type="vertical" size="l" />
        <CustomText
          text="Our application is currently undergoing scheduled maintenance."
          size="m"
          style={styles.centerText}
        />
        <CustomSpacing type="vertical" size="m" />
        <CustomText
          text="We'll be back online shortly. Thank you for your patience."
          size="m"
          style={styles.centerText}
        />
      </View>
    </BlankLayout>
  );
}

const styles = StyleSheet.create({
  webContainer: {
    justifyContent: "center",
    alignItems: "center",
    padding: 30,
    width: "40%",
    margin: "auto",
  },
  mobileContainer: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 15,
    width: "100%",
  },
  centerText: {
    textAlign: "center",
  },
});

export default MaintenanceModeView;
